var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E1DAFF",
    className: "profile-face-background"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "profile-face-color",
    d: "M16 6C21.523 6 26 10.477 26 16C26 21.523 21.523 26 16 26C10.477 26 6 21.523 6 16C6 10.477 10.477 6 16 6ZM16 15C14 15 12.333 15.333 11 16C11 17.3261 11.5268 18.5979 12.4645 19.5355C13.4021 20.4732 14.6739 21 16 21C17.3261 21 18.5979 20.4732 19.5355 19.5355C20.4732 18.5979 21 17.3261 21 16C19.667 15.333 18 15 16 15ZM12.5 11C11.348 11 10.378 11.78 10.088 12.84L10.05 13H14.95C14.8347 12.4353 14.5279 11.9278 14.0815 11.5633C13.635 11.1989 13.0763 10.9999 12.5 11ZM19.5 11C18.348 11 17.378 11.78 17.088 12.84L17.05 13H21.95C21.8347 12.4353 21.5279 11.9278 21.0815 11.5633C20.635 11.1989 20.0763 10.9999 19.5 11Z",
    fill: "#8B73EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8c47ed24d7a6e8ae170f5e44d1d77cde.svg";
export { ForwardRef as ReactComponent };